import {Directive, TemplateRef} from "@angular/core";

@Directive({standalone: true, selector: '[app-table-header]'})
export class AppTableHeaderTemplateDirective {
    constructor(public template: TemplateRef<any>) {
    }
}

@Directive({standalone: true, selector: '[app-table-body]'})
export class AppTableBodyTemplateDirective {
    constructor(public template: TemplateRef<any>) {
    }
}

@Directive({standalone: true, selector: '[app-table-footer]'})
export class AppTableFooterTemplateDirective {
    constructor(public template: TemplateRef<any>) {
    }
}